import { render, staticRenderFns } from "./actual-attributes-panel.vue?vue&type=template&id=6004b19c&"
var script = {}
import style0 from "../../../assets/styles/panels/_MultiBlockPanel.scss?vue&type=style&index=0&lang=scss&"
import style1 from "../../../assets/styles/panels/_ActualAttributesPanel.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports